import { render, staticRenderFns } from "./OrdenItemDoctor.vue?vue&type=template&id=0369dfc2&scoped=true&"
import script from "./OrdenItemDoctor.vue?vue&type=script&lang=js&"
export * from "./OrdenItemDoctor.vue?vue&type=script&lang=js&"
import style0 from "./OrdenItemDoctor.vue?vue&type=style&index=0&id=0369dfc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0369dfc2",
  null
  
)

export default component.exports